import { useGetParcel } from '~/api'
import { LoadingCircle } from '~/components'
import { getParcelLabelValues, Listing } from '~/models'

export default function ListingParcelData({ listing }: { listing: Listing }) {
  const { parcel, isLoading } = useGetParcel({
    parcelApn: listing.property.parcelApn,
    property: listing.property,
  })

  if (isLoading) {
    return (
      <div className="flex h-32 flex-col items-center justify-center">
        <LoadingCircle className="h-8 w-8 text-primary" />
        Loading parcel data...
      </div>
    )
  } else if (!parcel) {
    return (
      <div className="flex h-32 items-center justify-center">
        No parcel data found
      </div>
    )
  }

  return (
    <>
      <dl className="text-sm">
        {getParcelLabelValues(parcel.properties!).map(
          ({ key, label, value }) => {
            return (
              <div key={key} className="mb-1 grid grid-cols-12 border-b py-1.5">
                <dt className="col-span-5 font-medium leading-tight">
                  {label}:
                </dt>
                <dd className="col-span-7 capitalize">{value}</dd>
              </div>
            )
          }
        )}
      </dl>
      <p className="mt-4 text-sm italic text-muted-foreground">
        This information is provided by Regrid and is not maintained by
        Resimplifi
      </p>
    </>
  )
}
